import { Component, OnInit } from '@angular/core';
import { GolfCourse } from 'src/app/shared/golf-course';
import { GolfCoursesService } from 'src/app/shared/services/golf-courses.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-course-selector',
  templateUrl: './course-selector.component.html',
  styleUrls: ['./course-selector.component.css']
})
export class CourseSelectorComponent implements OnInit {

  courses: GolfCourse[];

  constructor(
    private golfCoursesService: GolfCoursesService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.golfCoursesService
      .getGolfCourses()
      .subscribe(data => {
        this.courses = data;
      });
  }
}
